__turbopack_context__.v({
  "blockWrapper": "DrawCounter-module__HUS-9a__blockWrapper",
  "container": "DrawCounter-module__HUS-9a__container",
  "countdown": "DrawCounter-module__HUS-9a__countdown",
  "digit": "DrawCounter-module__HUS-9a__digit",
  "digits": "DrawCounter-module__HUS-9a__digits",
  "heading": "DrawCounter-module__HUS-9a__heading",
  "separator": "DrawCounter-module__HUS-9a__separator",
  "timeBlock": "DrawCounter-module__HUS-9a__timeBlock",
});
